"use client";

import styles from "@/styles/newsletters/unsubscribe.module.scss";
import { useState } from "react";

import UnsubscribeForm from '@/components/newsletters/UnsubscribeForm'
import UnsubscribeSubmit from '@/components/newsletters/UnsubscribeSubmit'

export default function NewslettersUnSubscribe() {

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");

  return (
    <div className={styles["page-newsletters-unsubscribe"]}>
      <div className={styles["page-title"]}>
        Welcome, Customer<br></br> Manage Email Preferences
      </div>

      <div className={styles['desc']}>Please enter your email to modify your subscription preferences or unsubscribe from our email list.</div>

      { 
        step == 1 ? (
          <UnsubscribeForm
            onSuccess={(email: string) => {
              setStep(2);
              setEmail(email)
            }}
          />
        ) : null
      }
      
      { 
        step == 2 ? (
          <UnsubscribeSubmit
            email={email}
          />
        ) : null
      }
    </div>
  );
}
